/**
 * Identificadores e sistemas FHIR usados na gestão de comunicações (FluxZap).
 */

export const FLUXZAP_BASIC_NOTIFICATION_IDENTIFIER_SYSTEM =
  "https://fluxmed.cloud/fhir/CodeSystem/notifications";
export const FLUXZAP_BASIC_NOTIFICATION_IDENTIFIER_VALUE = "fluxzap";
export const FLUXZAP_BASIC_ORGANIZATION_IDENTIFIER_SYSTEM =
  "https://fluxmed.cloud/fhir/CodeSystem/OrganizationId";
export const FLUXZAP_BASIC_TEMPLATE_CODING_SYSTEM = "template";

/** Correlaciona Basic (quando presente) com Task.groupIdentifier. */
export const FLUXZAP_BASIC_BATCH_IDENTIFIER_SYSTEM =
  "http://fluxmed.cloud/fhir/flow-messaging/batchId";

export const FLUXZAP_TASK_BATCH_GROUP_IDENTIFIER_SYSTEM =
  "http://fluxmed.cloud/fhir/flow-messaging/batchId";
